const FAV_KEY = "ci_favorites";
const REC_KEY = "ci_recents";

const read = (k) => {
  try { return JSON.parse(localStorage.getItem(k)) || []; } catch { return []; }
};
const write = (k, v) => localStorage.setItem(k, JSON.stringify(v));

export const getFavorites = () => read(FAV_KEY);
export const isFavorite = (slug) => read(FAV_KEY).some((t) => t.slug === slug);
export const toggleFavorite = (tut) => {
  let favs = read(FAV_KEY);
  if (favs.some((t) => t.slug === tut.slug)) {
    favs = favs.filter((t) => t.slug !== tut.slug);
  } else {
    favs = [{ slug: tut.slug, title: tut.title, category: tut.category, difficulty: tut.difficulty }, ...favs];
  }
  write(FAV_KEY, favs);
  return favs;
};

export const getRecents = () => read(REC_KEY);
export const addRecent = (tut) => {
  let rec = read(REC_KEY).filter((t) => t.slug !== tut.slug);
  rec = [{ slug: tut.slug, title: tut.title, category: tut.category, difficulty: tut.difficulty }, ...rec].slice(0, 8);
  write(REC_KEY, rec);
  return rec;
};
